import { createSSRApp, h, type DefineComponent } from "vue";

import i18n from "@global/Plugins/i18n";
import { initLaravelEchoConnect } from "@global/Utilities/initLaravelEchoConnect";
import { createInertiaApp } from "@inertiajs/vue3";
import * as Sentry from "@sentry/vue";
import { createSentryPiniaPlugin } from "@sentry/vue";
import { client } from "laravel-precognition-vue-inertia";
import "nprogress/nprogress.css";
import { createPinia } from "pinia";
import { createPersistedState } from "pinia-plugin-persistedstate";
import { ZiggyVue } from "ziggy-js";
import Layout from "./Layouts/Layout.vue";

const pinia = createPinia();
pinia.use(createPersistedState({ auto: true }));
pinia.use(createSentryPiniaPlugin());

client.determineSuccessUsing((response) => response.status === 204);

const cleanApp = () => {
    document.getElementById("app")?.removeAttribute("data-page");
};

document.addEventListener("inertia:finish", cleanApp);

initLaravelEchoConnect();

createInertiaApp({
    resolve: async (name) => {
        const pages = import.meta.glob<DefineComponent>("./Pages/**/*.vue");
        const page = await pages[`./Pages/${name}.vue`]();
        page.default.layout = page.default.layout || Layout;
        if (!page) throw new Error(`Page ${name} not found`);
        return page;
    },
    setup({ el, App, props, plugin }) {
        const app = createSSRApp({ render: () => h(App, props) });

        Sentry.init({
            app,
            dsn: "https://908b72694bd09c56fef51795bf9852eb@o4509557667266560.ingest.de.sentry.io/4509557756723280",
            sendDefaultPii: true,
            tracesSampleRate: 0.1,
            integrations: [Sentry.browserTracingIntegration()],
            environment: import.meta.env.VITE_APP_ENV,
        });

        app.use(plugin).use(pinia).use(i18n).use(ZiggyVue).mount(el);
    },
    progress: {
        showSpinner: true,
        includeCSS: false,
    },
}).then(cleanApp);
